import { render } from "./LocationComponanet.vue?vue&type=template&id=62c5c67d&scoped=true"
import script from "./LocationComponanet.vue?vue&type=script&lang=js"
export * from "./LocationComponanet.vue?vue&type=script&lang=js"

import "./LocationComponanet.vue?vue&type=style&index=0&id=62c5c67d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c5c67d"]])

export default __exports__